// extracted by mini-css-extract-plugin
export default {"errorMain":"src-components-ErrorBoundary-error-module_errorMain--wcjw7","errorMainText":"src-components-ErrorBoundary-error-module_errorMainText--bMBr3"};